import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
// @mui
import { Box, Button, Container, Typography } from '@mui/material';
// components
import Page from '../../components/Page';
import { SeverErrorIllustration } from '../../assets';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function PermissionRequired() {
  return (
    <Page title='No Permission' sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <Typography variant='h3' paragraph>
              Permission Required
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Opz. Looks like you don't have permission to access this page.</Typography>

            <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
